import { ChangeEvent, TableRow } from "@mcleod/components";
import { GeneralSettings, ModelRow, Navigation } from "@mcleod/core";
import { AutogenLayoutKeyboardShortcutsTable } from "./autogen/AutogenLayoutKeyboardShortcutsTable";
import { UIDesigner } from "./UIDesigner";

export class KeyboardShortcutsTable extends AutogenLayoutKeyboardShortcutsTable {
    public runningInDialog: boolean = false;

    onLoad(): void | Promise<void> {
        this.textboxInput.addChangeListener((event: ChangeEvent) => {
            this.tableKeyboardShortcuts.customFilter = (tableRow: TableRow) => {
                return Object.keys(tableRow.data.data).some((key) => {
                    const value = tableRow.data.get(key);
                    return value != null && value.toString().toLowerCase().includes(event.newValue.toLowerCase());
                });
            }
        });
        this.buttonOpenInNewWindow.addClickListener(() => {
            Navigation.navigateTo("designer/ui/KeyboardShortcutsTable", {
                width: 700,
                height: 800,
                newTab: true,
                windowDecorators: false
            });
        });
        this.loadTable();
        this.buttonOpenInNewWindow.visible = this.runningInDialog;
    }

    public loadTable() {
        const runningInTailer: boolean = GeneralSettings.getSingleton().isRunningInIDE() === false;
        const designer = new UIDesigner();
        designer.getKeyHandlers().filter(keyHandler => keyHandler.key !== "ALL" && (runningInTailer ? (keyHandler.renderInTailer !== false) : true)).forEach(keyHandler => {
            const row = new ModelRow("", false);
            const keyShortcutModifiers = (keyHandler.modifiers?.ctrlKey ? "Ctrl + " : "") + (keyHandler.modifiers?.altKey ? "Alt + " : "") + (keyHandler.modifiers?.shiftKey ? "Shift + " : "");
            row.set("key_shortcut", keyShortcutModifiers.length > 0 ? `${keyShortcutModifiers}${keyHandler.key}` : keyHandler.key);
            row.set("description", keyHandler.description);
            this.tableKeyboardShortcuts.addRow(row, null, { display: true, addToData: false });
        });
    }
}
